import { BaseListPaginatedGateway, type Backend, type BaseGatewayErrorDTO } from '@cplug/frontend-core/gateways'
import type { AxiosResponse } from 'axios'
import { useGatewayErrorHandler } from '../composables/useGatewayErrorHandler'
import { setupNavigationAbortInterceptor } from '../composables/useNavigationAbort'
import { CPIdempotencyKeyGenerator } from './CPBaseGateway'
import { useBugsnag } from '#imports'

export abstract class CPBaseListPaginatedGateway<
  Model,
  DTO,
  ListDTO extends { [key: string]: DTO[] }
> extends BaseListPaginatedGateway<Model, DTO, ListDTO> {
  constructor () {
    super({
      errorTracker: useBugsnag(),
      idempotencyKeyGenerator: new CPIdempotencyKeyGenerator()
    })
  }

  protected override handleErrorCodes (url: string, response: AxiosResponse<BaseGatewayErrorDTO>): void {
    useGatewayErrorHandler(url, response)
  }

  protected override setup (backend: Backend): void {
    super.setup(backend)
    setupNavigationAbortInterceptor(this.api)
  }
}
